import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Initial State
const initialState = {
  users: [],
  partners: [],
  products: [],
  orders: [],
  analytics: {},
  settings: {},
  loading: false,
  error: null,
  successMessage: null,
};

// Admin Slice
const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  clearError,
  clearSuccessMessage,
  setLoading,
} = adminSlice.actions;

export default adminSlice.reducer;